<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <leave-header :info="otherData" />

        <leave-wife
          :title="formTitle"
          @updateOtherData="onUpdateOtherData"
          @updateLoading="onUpdateLoading"
        />
      </v-container>
    </v-main>

    <div
      v-show="loading"
      style="position: fixed; bottom: 4px; left: 4px; z-index: 5;"
    >
      <v-progress-circular indeterminate color="primary" />
    </div>
  </div>
</template>

<script>
import LeaveHeader from '@/components/leave/LeaveHeader'
import LeaveWife from '@/components/leave/LeaveForm/LeaveWife'

export default {
  components: {
    LeaveHeader,
    LeaveWife
  },

  data() {
    return {
      loading: true,
      otherData: {}
    }
  },

  computed: {
    title() {
      return this.isEditMode
        ? 'แก้ไขการขอลาไปช่วยเหลือภริยาที่คลอดบุตร - ' +
            this.$route.params.leaveOrderId
        : 'การขอลาไปช่วยเหลือภริยาที่คลอดบุตร'
    },

    formTitle() {
      return this.isEditMode
        ? 'แก้ไขแบบฟอร์มการขอลาไปช่วยเหลือภริยาที่คลอดบุตร - ' +
            this.$route.params.leaveOrderId
        : 'แบบฟอร์มการขอลาไปช่วยเหลือภริยาที่คลอดบุตร'
    },

    isEditMode() {
      return !!this.$route.params.leaveOrderId
    }
  },

  methods: {
    onUpdateOtherData(otherData) {
      this.otherData = otherData
    },

    onUpdateLoading(loading) {
      this.loading = loading
    }
  }
}
</script>
